<div class="container px-0 h-100">
  @if (!isUploading) {
    <div class="row h-100 align-items-center">
      <div class="col">
        @if (fileTooLarge==true) {
          <small class="text-danger d-block mt-3 fw-bold text-center text-sm">
            Die ausgewählte Datei ist zu groß. Bitte wählen Sie eine Datei mit Dateigröße kleiner als
            {{ message.Payload.MaximumFileSize / 1000 | number:'1.0-0' }} MB.
          </small>
        }
      </div>
      <div class="col-auto">
        <sc-file-button (filesChanged)="upload($event)" #fileinput [accept]="message.Payload.FileType">
          <div class="btn btn-secondary">
            @if (message.Payload.Label) {
              <span>{{ message.Payload.Label }}</span>
            }
            @if (!message.Payload.Label) {
              <span>Datei auswählen</span>
            }
          </div>
        </sc-file-button>
      </div>
    </div>
  }
  @if (isUploading) {
    <div class="row h-100 align-items-center">
      <div class="col-12">
        <sc-progressbar [value]="uploadProgress" [success]="uploadSuccess" [error]="uploadError" (retryClick)="retryAfterError()"></sc-progressbar>
      </div>
    </div>
  }
</div>